export default "__VITE_PUBLIC_ASSET__d8e936d1__"